export default __webpack_public_path__ + "static/media/Path 140.7785da54.svg";